
import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {fuseAnimations} from '../../../../core/animations';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import {CdkDragDrop , moveItemInArray} from '@angular/cdk/drag-drop';

import {DefaultFormDialogComponent} from './setting-form/setting-form.component';
import {UserService} from "../../../../core/services/users.service";

import {NgxSpinnerService} from "ngx-spinner";
import {ToastrService } from "ngx-toastr";
import {FuseConfigService} from "../../../../core/services/config.service";
import {Router} from "@angular/router";
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {FuseDeleteDialogComponent} from '../../../../core/components/delete-dialog/delete-dialog.component';
import { PlatformsService } from '../../../../core/services/platforms.service';


@Component({
    selector: 'default-page',
    templateUrl: './default.component.html',
    styleUrls: ['./default.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class DefaultComponent implements OnInit, OnDestroy {

  tutorials;
  dialogRef: any;
  write = true;
  sortList = false;
  term;
  role;
  platforms;
  selectedPlatform;
  public subscription = new Subscription();

  constructor (private http: HttpClient , private userService: UserService ,
               public dialog: MatDialog , public snackBar: MatSnackBar ,
               private spinner: NgxSpinnerService , public toastr: ToastrService  ,
               private fuseConfig: FuseConfigService, private router: Router, public translate: TranslateService,
               private platformsService: PlatformsService) {
    this.fuseConfig.role.subscribe(res => {
      this.role = res;
    });
  }

  ngOnInit () {
    this.spinner.show();
    this.getPlatforms();

  }

  getPlatforms() {
    this.platformsService.getPlatforms().subscribe((res: any) => {
      if (res && res.length) {
        this.platforms = res;
        this.selectedPlatform = this.platforms[0].id;
        this.getDataTutorial();
        this.subscription.add(this.translate.onLangChange.subscribe(change => {
          this.getDataTutorial();
        }));
      }
    });
  }

  changePlatforms(platform) {
    this.selectedPlatform = platform.value;
    this.getDataTutorial();
  }

  ngOnDestroy () {
    this.subscription.unsubscribe();
  }

  getDataTutorial () {
    this.spinner.show();
    const lang = this.translate.currentLang;
    this.userService.getDefault(lang, this.selectedPlatform).subscribe((res: any) => {
      if (res) {
        this.tutorials = res;
      }
      this.spinner.hide();
    });
  }

  newPolicy () {
    let type = {
      name: 'Privacy(Admin)' ,
      description: '' ,
      text: '' ,
      key: '' ,
      type: 'default',
      lang: this.translate.currentLang,
      platformId: this.selectedPlatform
    };
    // this.userService.privacyAdmin().subscribe((res: any) => {
      this.dialogRef = this.dialog.open(DefaultFormDialogComponent , {
        panelClass: 'contact-form-dialog' ,
        width: '70vw' ,
        data: {
          data: type ,
          action: 'new'
        }
      });
      this.dialogRef.afterClosed()
        .subscribe(response => {
          if (!response) {
            return;
          }
          // console.log(response);
          const actionType: string = response[ 0 ];

          switch (actionType) {
            /**
             * Save
             */
            case 'save':
              const data = response[ 1 ];
              type.text = data.html;
              type.name = data.title;
              type.description = data.description;
              this.userService.addDynamicData(type).subscribe((res) => {
                if (res) {
                  this.toastr.success('DynamicData updated' , 'Success!');
                  this.getDataTutorial();
                }
              } , error => {
                this.toastr.error('DynamicData fail' , 'Error!');
              });
              break;
            /**
             * Delete
             */
            case 'delete':


              break;
          }
        });
    // });

  }

  drop (event: CdkDragDrop<string[]>) {
    moveItemInArray(this.tutorials , event.previousIndex , event.currentIndex);
    console.log(this.tutorials);
    let i = 0;
    this.tutorials.map((item) => {
      i++;
      item.sort = i;
    });
    this.userService.updateSort(this.tutorials).subscribe();
  }


  show (data) {
    let dataInfo = Object.assign({}, data);
    if (this.role !== 'superAdmin') {
      const lang = this.translate.currentLang;
      this.userService.privacyAdmin(lang).subscribe((res: any) => {
        dataInfo['text'] = res.text + '<br/>' + dataInfo['text'];
        this.dialogRef = this.dialog.open(DefaultFormDialogComponent , {
          panelClass: 'contact-form-dialog' ,
          width: '70vw' ,
          data: {
            action: 'show' ,
            data:  dataInfo
          }
        });
      });
    } else {
      this.dialogRef = this.dialog.open(DefaultFormDialogComponent , {
        panelClass: 'contact-form-dialog' ,
        width: '70vw' ,
        data: {
          action: 'show' ,
          data: data
        }
      });
    }

  }

  editType (type , event) {
    event.stopPropagation();
    this.dialogRef = this.dialog.open(DefaultFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '70vw' ,
      data: {
        data: type ,
        action: 'edit'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        // console.log(response);
        const actionType: string = response[ 0 ];

        switch (actionType) {
          /**
           * Save
           */
          case 'save':

            const data = response[ 1 ];
            type.name = data.title;
            type.text = data.html;
            this.userService.addDynamicData(type).subscribe((res) => {
              if (res) {
                this.toastr.success('DynamicData updated' , 'Success!' );
                this.getDataTutorial();
              }
            } , error => {
              this.toastr.error('DynamicData fail' , 'Error!');
            });
            break;
          /**
           * Delete
           */
          case 'delete':


            break;
        }
      });
  }

  openInWeb(id, event) {
    event.stopPropagation();
    window.open(window.location.origin + '/information?type=' + id, '_blank');
  }

  delete(id, event) {
    event.stopPropagation();
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.userService.deleteDynamicData(id).subscribe(res => {
          this.getDataTutorial();
        });
      }
    });
  }
}

